import React from 'react';
import Navbar from '../components/Navbar.tsx';
import Footer from '../components/Footer.tsx';
import FeedbackFAB from '../components/ui/FeedbackFAB.tsx';
import FeedbackModal from '../components/ui/FeedbackModal.tsx';
import UploadWizard, { WizardContainer } from '../components/UploadWizard/index.tsx';
import { useSession } from '../hooks/useSession.ts';

const UploadScreen: React.FC = () => {
  const { session } = useSession();

  return (
    <div className="min-h-screen bg-gray-50 font-sans flex flex-col">
      <Navbar />
      <main className="container mx-auto px-2 py-2 flex-1">
        <WizardContainer variant="full">
          <UploadWizard variant="full" />
        </WizardContainer>
      </main>
      <Footer />

      {/* Feedback components - only show for authenticated users */}
      {session && (
        <>
          <FeedbackFAB onClick={() => {}} />
          <FeedbackModal
            isOpen={false}
            onClose={() => {}}
          />
        </>
      )}
    </div>
  );
};

export default UploadScreen; 